import InterviewQuestionsManager from './InterviewQuestionsManager.container';

export default InterviewQuestionsManager;
